import { Box, Text } from "@chakra-ui/react";
import { DragEvent, TouchEvent, useState } from "react";

interface DropZoneProps {
    id: string,
    text: string,
    isVisible: boolean,
    isTouchOver: boolean,
    onDrop: (e: DragEvent<HTMLDivElement>) => void,
    onTouchEnd: (e: TouchEvent) => void
}

export const DropZone = (props: DropZoneProps) => {
    const { id, text, isVisible, isTouchOver, onDrop, onTouchEnd } = props;
    const [isActive, setIsActive] = useState(false);

    const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsActive(true);
    };

    const handleDragLeave = () => {
        setIsActive(false);
    };

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsActive(false);
        onDrop(e);
    };

    return (!isVisible) ? null :
        (<Box id={id}
            h="50px"
            mb={3}
            border="2px dashed"
            borderColor={isActive || isTouchOver ? "blue.400" : "gray.300"}
            bg={isActive || isTouchOver ? "blue.50" : "transparent"}
            borderRadius="md"
            display="flex"
            alignItems="center"
            justifyContent="center"
            transition="all 0.2s"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onTouchEnd={onTouchEnd}
        >
            <Text fontSize="sm" color="gray.600">{text}</Text>
        </Box>
    );
};